import {
    faBars,
    faArrowTrendUp,
    faXmark,
    faBookOpen,
    faCircleXmark,
    faUpload,
    faSquareCheck,
    faMagnifyingGlass,
    faCartShopping,
    faCircleInfo,
    faChevronDown,
    faChevronUp,
    faLock,
    faLightbulb
} from '@fortawesome/free-solid-svg-icons'
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons'

export const icons = {
    arrowTrendUp: faArrowTrendUp,
    bars: faBars,
    xMark: faXmark,
    circle: faCircle,
    bookOpen: faBookOpen,
    upload: faUpload,
    circleXmark: faCircleXmark,
    square: faSquare,
    squareCheck: faSquareCheck,
    cart: faCartShopping,
    chevronDown: faChevronDown,
    chevronUp: faChevronUp,
    info: faCircleInfo,
    magnifyingGlass: faMagnifyingGlass,
    lock: faLock,
    lightbulb: faLightbulb
};

export type IconName = keyof typeof icons;
